var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';
import { useDinPlayerContext } from 'hx-din-test-2';
import { AnimatedCircles, SideImageLayout, StartButton } from 'hx-ui';
import { useManualPreloadImages } from 'hx-util';
import { useNavigate } from 'react-router-dom';
import { pageImages } from '@/pages/images';
import { palette } from '@/theme/palette';
import { LogoAndHeading } from '@/components/logo-and-heading.component';
import { OverLayBanner } from '@/components/overlay-banner.component';
import { useSendButtonClick } from '@/hooks/use-send-button-click.hook';
import WelcomePageSubheader from '@/components/welcome-page/welcome-page-subheader.component';
import { InformationToggle } from '@/components/information-toggle.component';
import { IconPoweredByHearX } from 'hx-assets';
var imagesToPreload = {
    desktop: __spreadArray([], Object.values(pageImages), true),
};
export function WelcomePage() {
    var _this = this;
    var loadImages = useManualPreloadImages(imagesToPreload).loadImages;
    var theme = useTheme();
    var navigate = useNavigate();
    var handleSendButtonClick = useSendButtonClick().handleSendButtonClick;
    var _a = useDinPlayerContext(), initialize = _a.initialize, progress = _a.state.progress;
    var handleStartClick = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadImages();
                    return [4 /*yield*/, handleSendButtonClick('widget_started')];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, initialize()];
                case 2:
                    _a.sent();
                    navigate('/setup/hearing-in-noisy-places');
                    return [2 /*return*/];
            }
        });
    }); };
    var isMobile = useMediaQuery(theme.breakpoints.down('lg'), { noSsr: true });
    return (_jsx(SideImageLayout, { leftPanelWidth: "40%", imageLeft: pageImages.womanTypingOnLaptop, imageStyle: {
            backgroundSize: 'cover',
            backgroundPosition: '50% 50%',
            backgroundRepeat: 'no-repeat',
        }, overlayedContent: _jsx(OverLayBanner, { content: _jsx("span", __assign({ className: "h-6" }, { children: "Clinically validated" })), className: "bg-banner-brown text-center text-xl font-bold text-faux-black py-4" }), header: _jsxs("header", __assign({ className: "grid gap-2 place-content-center" }, { children: [_jsx(LogoAndHeading, { headingText: 'Hearing test', image: {
                        height: isMobile ? 50 : 75,
                        width: isMobile ? 170 : 250,
                    }, className: "mt-6 gap-1 font-extrabold text-2xl lg:text-3xl" }), _jsx(WelcomePageSubheader, { isMobile: isMobile })] })), content: _jsx("main", __assign({ className: "items-center py-32 md:py-16" }, { children: _jsx(StartButton, { onClick: handleStartClick, progress: progress, color: theme.palette.secondary.main, GraphicElement: AnimatedCircles, graphicElementProps: {
                    colorTransform: function (index) {
                        var colors = [
                            palette.common['faux-black'],
                            palette.common['beige'],
                            palette.common['banner'],
                        ];
                        return colors[index];
                    },
                    opacityTransform: function (index) {
                        return 0.7 - 0.2 * index;
                    },
                }, buttonStyles: {
                    color: theme.palette.common.white,
                    minWidth: '7.25rem',
                    minHeight: '7.25rem',
                    textTransform: 'uppercase',
                } }) })), footer: _jsxs("div", __assign({ className: 'flex flex-col items-center w-full gap-3' }, { children: [_jsx(InformationToggle, __assign({ title: "Your hearing test, explained", chevronColor: theme.palette.primary.main }, { children: _jsx(Typography, { children: "This test measures how well you hear speech in noisy places. With headphones, you\u2019ll listen to numbers spoken against different levels of background noise \u2013 similar to a busy restaurant or outdoor event." }) })), _jsx(Typography, __assign({ className: "text-xs font-extralight lg:text-sm px-4 lg:font-medium" }, { children: "Validated speech-in-noise (SIN) hearing test (2016 International Journal of Audiology, 2018 Ear and Hearing)." })), _jsx("div", __assign({ className: 'grid w-full place-items-center pb-4' }, { children: _jsx(IconPoweredByHearX, { className: "flex w-[180px]" }) }))] })) }));
}
